// dependencies
import { List, Map } from "immutable";

const initialState = Map({
	user: Map(),
	userSettings: Map(),
	userAliases: List(),
	userDefaultAlias: null,
	debug: false,
	measurements: Map(),
	features: Map(),
});

export default function invitation(state = initialState, action) {
	switch (action.type) {
		case "APPLICATION:INIT":
			return state;

		case "APPLICATION:USER":
			return state.set("user", action.user);

		case "APPLICATION:FEATURES":
			return state.set("features", action.features);

		case "APPLICATION:DEBUG":
			return state.set("debug", action.isDebug);

		case "APPLICATION:MEASURE": {
			const appDimensions = {
				width: action.windowDimensions.width - 0,
				height: action.windowDimensions.height - (45 + 51),
			};

			return state.withMutations((nest) => {
				nest.set("isMobileView", action.isMobileView);
				nest.set("appMeasurements", Map(appDimensions));
				nest.set("measurements", Map(action.windowDimensions));
			});
		}

		case "SETTINGS:GETUSERSETTINGS@SUCCESS": {
			return state.setIn(["userSettings"], action.response.get("settings", Map()));
		}

		case "USERS:ME@SUCCESS": {
			return state.withMutations((mutable) => {
				mutable.setIn(["userAliases"], action.response.getIn(["me", "aliases"], List()));
				mutable.setIn(["authorization"], action.response.getIn(["me", "authorization"], List()));
				mutable.setIn(["userDefaultAlias"], action.response.getIn(["me", "defaultCompanyID"], null));
			});
		}

		default:
			// never forget your default return state!
			return state;
	}
}
